import QXC7 from './QXC7.js'

export default {
  ...QXC7
}
